import { create } from "zustand";

const useComingSoonStore = create((set) => ({
  isOpen: false,
  title: null,
  message: null,
  open: (options = {}) =>
    set({
      isOpen: true,
      title: options.title || null,
      message: options.message || null,
    }),
  close: () => set({ isOpen: false, title: null, message: null }),
}));

export const useComingSoon = () => {
  const { open, close, isOpen, title, message } = useComingSoonStore();

  return {
    showComingSoon: open,
    hideComingSoon: close,
    isComingSoonOpen: isOpen,
    comingSoonTitle: title,
    comingSoonMessage: message,
  };
};

export default useComingSoonStore;
